module.exports = __webpack_public_path__ + "static/mobile-click-spoofing-1b36c35d071237606b4039c80399ba8e.gif";